module.exports = __webpack_public_path__ + "static/img/4.54c6db1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/sp/4.png
// module id = yyP7
// module chunks = 0